import React from 'react';
import { css, styled } from 'styled-components';
import { Icon } from '../../common';

export function ProcessStartWizardRowLabel(props: {
    hasActionComponent?: boolean;
    header?: boolean;
    icon?: string;
    label?: string;
    result?: boolean;
}): React.ReactElement {
    return (
        <StyledFormWizardLabel
            $hasActionComponent={Boolean(props.hasActionComponent)}
            $hasHeader={props.header}
        >
            {props.result && <StyledIcon icon={props.icon || 'male-care-provider'} />}
            <StyledLabel $hasHeader={props.header}>{props.label}</StyledLabel>
        </StyledFormWizardLabel>
    );
}

const StyledFormWizardLabel = styled.div<{ $hasActionComponent?: boolean; $hasHeader?: boolean }>`
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    flex: 0 0 100%;
    max-width: 100%;

    ${({ theme }) => theme.mediaQueries.small} {
        flex: 0 0 25%;
        max-width: 25%;
    }

    ${({ $hasHeader }) =>
        $hasHeader &&
        css`
            order: 1;
        `}

    ${({ $hasActionComponent }) =>
        $hasActionComponent &&
        css`
            flex: 0 0 58.3333%;
            max-width: 58.3333%;
        `}
`;

const StyledIcon = styled(Icon)<{ icon?: string }>`
    ${({ icon, theme }) =>
        icon &&
        css`
            margin-right: ${theme.space[2]};
        `}
`;

const StyledLabel = styled.label<{ $hasHeader?: boolean }>`
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    font-size: 0.875rem;
    line-height: 1.5;
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    min-height: calc(2.25rem + 2px);
    margin-bottom: 0;

    ${({ $hasHeader, theme }) =>
        $hasHeader &&
        css`
            line-height: 1.375rem;
            font-size: ${theme.fontSizes.xl};
        `}
`;
